import React, { createContext, ReactNode } from "react";
import type { ApiService } from "@onetasklist/shared";

export const ApiContext = createContext<ApiService | null>(null);

interface ApiProviderProps {
  children: ReactNode;
  api?: ApiService;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children, api }) => {
  return (
    <ApiContext.Provider value={api ?? null}>{children}</ApiContext.Provider>
  );
};
